import { AbstractControl, ValidatorFn } from "@angular/forms";

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const url = control.value;
    let normalizedUrl = url;
    if (url.trim() !== '') {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        normalizedUrl = `https://${url}`;
      }
      let parsedUrl: URL;
      try {
        parsedUrl = new URL(normalizedUrl);
        const urlRegex = /^(https?:\/\/)?(([^\s/]+)\.([a-z]{2,6}\.?))(:\d{1,5})?(.*)?$/i;
        if (!urlRegex.test(normalizedUrl)) {
          return {'invalidUrl': true};
        }
        const suspiciousCharacters = ["<", ">", "\"", "'", ";", "--", "/*", "*/", "(", ")", "{", "}", "[", "]", "\\"];
        if (suspiciousCharacters.some(char => url.includes(char))) {
          return {'invalidUrl': true};
        }
        return null;
      } catch (error) {
        return {invalidUrl: true};
      }
    }
    return null;
  }
}
